var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-4 align-items-center"},[_c('div',{staticClass:"col-4"},[_c('span',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"col-8"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }